import { createContext } from "react";

/**
 * Timeout Configuration
 */
type TimeoutConfig = {
  // Idle detection (deselect shot + show overlay)
  idleTimeoutMs: number;
  // Inactivity detection
  inactivityTimeoutMs: number;
  modalResponseTimeoutMs: number;

  // Auto-claim delay before opening overlay
  autoClaimDelayMs: number;

  // Auto-claim close timeout
  autoClaimCloseTimeoutMs: number;

  // Radar consent POST timeout
  radarConsentTimeoutMs: number;

  // Loading state
  isLoading: boolean;
};

/**
 * Timeout Configuration Context
 *
 * Centralized configuration for all timeout-related values.
 * Values come from RadarConfig API with fallback to defaults.
 */
export const TimeoutConfigContext = createContext<TimeoutConfig | undefined>(
  undefined
);
